import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Stack,
} from "@mui/material";
import chatImage from "./firstCardImg.gif"; // Replace with actual image path
import analyticsImage from "./secondCardImg.gif"; // Replace with actual image path

const Section11A1 = ({ data, index }) => {
  console.log("data123:",  data[index]?.features[0]?.title);

  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        justifyContent: "center",
        // marginTop: { xs: "32px", sm: "0px" },
      }}
    >
      <Stack
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: {
              xl: "row",
              lg: "row",
              md: "row",
              sm: "row",
              xs: "column",
            },
            // border: "2px solid blue",
            width: { md: "91%", sm: "94%", xs: "94%" },
            gap: 2,
          }}
        >
          <Card
            sx={{
              display: "flex",
              flexDirection: "column", // Stacked layout for mobile
              alignItems: "center",
              boxShadow: "none",
              border: "1px solid #E0E0E0",
              // padding: "16px",
              backgroundColor: "#F9F9FF",
              // height: { xs: "auto", xl: "100%" }, // Auto height for mobile, full height for larger screens
              // width: { xs: "80%" },
              textAlign: { xs: "center", md: "left" },
            }}
          >
            <CardContent
              sx={{
                width: "100%",
                // paddingBottom: "16px",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  marginBottom: "8px",
                  textAlign: { xs: "left", md: "left" }, // Center-align for mobile
                  fontFamily: "'Roboto', sans-serif",
                  fontSize: {
                    xs: "20px",
                  },
                  lineHeight: {
                    xs: "24px",
                  },
                  fontWeight: 600,
                  color: "rgb(5 78 146)",
                }}
              >
                {/* Feature 123 */}
                {data[index]?.features[0]?.title || "title"}
               
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  marginBottom: "16px",
                  textAlign: { xs: "left", md: "left" }, // Center-align for mobile
                  fontFamily: "'Roboto', sans-serif",
                  fontSize: {
                    xs: "16px",
                  },
                  lineHeight: {
                    xs: "20px",
                  },
                  fontWeight: 400,
                  color: "#333",
                }}
              >
                {data[index]?.features[0]?.description2 || "description"}
                {/* Monitor Read, Replied & Clicked rates for each campaign and
                retarget smartly for higher conversions! */}
              </Typography>
            </CardContent>
            <CardMedia
              component="img"
              // image={chatImage}
              image={data[index]?.features[0]?.img || chatImage } 
              alt="Build no-code Chatbot"
              sx={{
                width: { xs: "90%", md: "80%" }, // Responsive width
                height: { xs: "auto", md: "60%" }, // Responsive height
                borderRadius: "8px",
                marginTop: { xs: "16px", md: "0" }, // Add margin on mobile for spacing
              }}
            />
          </Card>

          <Card
            sx={{
              display: "flex",
              flexDirection: "column", // Stacked layout for mobile
              alignItems: "center",
              boxShadow: "none",
              border: "1px solid #E0E0E0",
              backgroundColor: "#F9F9FF",
              textAlign: { xs: "center", md: "left" },
            }}
          >
            <CardContent
              sx={{
                width: "100%",
                // paddingBottom: "16px",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  marginBottom: "8px",
                  textAlign: { xs: "left", md: "left" }, // Center-align for mobile
                  fontFamily: "'Roboto', sans-serif",
                  fontSize: {
                    xs: "20px",
                  },
                  lineHeight: {
                    xs: "24px",
                  },
                  fontWeight: 600,
                  color: "rgb(5 78 146)",
                }}
              >
                {/* Feature 2 */}
                {data[index]?.features[1]?.title || "title"}
              </Typography>
              {/* <Typography
                variant="body2"
                sx={{
                  marginBottom: "16px",
                  textAlign: { xs: "left", md: "left" }, // Center-align for mobile
                  display: { xs: "none", sm: "none" },
                }}
              >
                Track your campaign results in real-time.
              </Typography> */}
              <Typography
                variant="body2"
                sx={{
                  marginBottom: "16px",
                  textAlign: { xs: "left", md: "left" }, // Center-align for mobile
                  fontFamily: "'Roboto', sans-serif",
                  fontSize: {
                    xs: "16px",
                  },
                  lineHeight: {
                    xs: "20px",
                  },
                  fontWeight: 400,
                  color: "#333",
                }}
              >
                {data[index]?.features[1]?.description2 || "description"}
                {/* Monitor Read, Replied & Clicked rates for each campaign and
                retarget smartly for higher conversions! */}
              </Typography>
            </CardContent>
            <CardMedia
              component="img"
              // image={chatImage}
              image={data[index]?.features[1]?.img || chatImage } 
              alt="Build no-code Chatbot"
              sx={{
                width: { xs: "90%", md: "80%" }, // Responsive width
                height: { xs: "auto", md: "60%" }, // Responsive height
                borderRadius: "8px",
                marginTop: { xs: "16px", md: "0" }, // Add margin on mobile for spacing
              }}
            />
          </Card>
        </Box>
      </Stack>
    </Stack>
  );
};

export default Section11A1;
